import LibraryPage from '../views/library'
import CollectionPage from '../views/library/collection'

import type { Route } from './routes'

export const LIBRARY_ROUTES: Route[] = [
  {
    name: 'Library',
    path: '/library',
    component: LibraryPage
  },
  {
    name: 'Collection',
    path: '/library/collection/:id',
    component: CollectionPage
  }
]
